function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 44 44",
  role: "img",
  "aria-hidden": "true"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  d: "M22 44A22 22 0 100 22a22 22 0 0022 22z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M19.12 12.05a.36.36 0 00.26.11.38.38 0 00.26-.11l1.88-1.89 1.89 1.89a.36.36 0 00.52 0 .37.37 0 000-.52L22 9.65l1.89-1.89a.37.37 0 10-.52-.52l-1.85 1.89-1.88-1.89a.37.37 0 00-.52.52L21 9.65l-1.89 1.88a.37.37 0 00.01.52zM32 32.22L21.76 15.91l-.05-.06h-.4l-.05.06L11 32.22a.37.37 0 00.12.5.35.35 0 00.19.06.37.37 0 00.32-.17l3.74-6 5.76 4.1v7.18a.37.37 0 10.74 0v-7.2l5.75-4.1 3.75 6a.37.37 0 00.32.17.35.35 0 00.19-.06.37.37 0 00.12-.48zm-10.92-2.41L15.71 26l5.37-8.6zm.74 0V17.39L27.18 26z"
}));